import 'simplebar';
import 'simplebar/dist/simplebar.css';
import Braze from '../../libraries/Braze';
import '../../styles/templates/customers/account-in.scss';

(() => {
    // This module ships in the site-wide bundle, so only count the signup on the
    // account page the register form returns to.
    const onAccountPage = window.location.pathname.replace(/\/$/, '').endsWith('/account');
    const params = new URLSearchParams(window.location.search);
    if (onAccountPage && params.get('signup') === '1') {
        Braze.logOnlineSignup({ source: 'shopify_account' });
        params.delete('signup');
        const qs = params.toString();
        const newUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
        window.history.replaceState({}, '', newUrl);
    }

    // DOB is exposed by account.liquid from the customer metafield (YYYY-MM-DD).
    const dob = window.__customerDob;
    if (typeof dob === 'string') {
        const [year, month, day] = dob.split('-').map(Number);
        if (year && month && day) {
            Braze.setDateOfBirth(year, month, day);
        }
    }
})();
